"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThresholdPill = void 0;
var React = __importStar(require("react"));
var Common_1 = require("../Common");
var Pill_1 = require("./Pill");
// export interface IThresholdPillState {
// 	size: 'sm' | 'lg';
// 	text: string;
// }
var ThresholdPill = /** @class */ (function (_super) {
    __extends(ThresholdPill, _super);
    function ThresholdPill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // constructor(props: IThresholdPillProps) {
    // 	super(props);
    // 	this.state = {
    // 		size: props.size ? props.size : 'lg',
    // 		text: this.getInnerText(props),
    // 	};
    // }
    // public componentWillReceiveProps(nextProps: IThresholdPillProps) {
    // 	this.setState({ text: this.getInnerText(nextProps) });
    // }
    ThresholdPill.prototype.getInnerText = function () {
        var text = this.props.count.toString();
        if (this.props.showThresholdCount !== undefined && this.props.threshold !== undefined) {
            text += ' of ' + this.props.threshold.toString();
        }
        return text;
    };
    ThresholdPill.prototype.countExceedsThreshold = function () {
        if (this.props.threshold === undefined) {
            return false;
        }
        return this.props.count > this.props.threshold;
    };
    ThresholdPill.prototype.render = function () {
        var countExceedsThreshold = this.countExceedsThreshold();
        return (this.props.count !== undefined && (React.createElement(Pill_1.Pill, { className: this.props.size, warning: countExceedsThreshold, attached: this.props.attached },
            React.createElement("div", null,
                this.getInnerText(),
                countExceedsThreshold && ' ' && React.createElement(Common_1.Icon, { name: 'table-warning' })))));
    };
    ThresholdPill.defaultProps = {
        size: 'lg',
    };
    return ThresholdPill;
}(React.Component));
exports.ThresholdPill = ThresholdPill;
